import React, { useEffect, useState }  from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import Swal from 'sweetalert2'
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';

const validationSchema = yup.object({
    name: yup.string('Enter your name').required('Name is required')
});
export const SaveSubmitModal = ({show, setShow, handleNext, isRater, subjectName, ...rest}) => {
    const handleClose = () => setShow(false);

    const handlePopupClose = () => {
        handleClose()
    }
    return (
        <Modal show={show} onHide={handlePopupClose}>
            <Modal.Header closeButton>
            <Modal.Title>Save & Submit</Modal.Title>
            </Modal.Header>
                <Modal.Body> 
                    <div className="mb-3">
                        <p>Thank you for taking the time to complete {isRater ? subjectName+"'s" : 'your'} 360 Feedback</p>
                        <p>Your thoughtful feedback is greatly appreciated and provides valuable insight for development and growth.</p>
                        <p>If you are satisfied with your responses and wish to submit your feedback, please click <b>Save and Submit</b> below.</p>
                    </div> 
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>
                    <button type="submit" className="btn btn-primary" onClick={() =>{ handleNext('1')} }>Save & Submit</button>
                </Modal.Footer>
        </Modal>
    )
}
export default SaveSubmitModal;
SaveSubmitModal.propTypes = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    handleNext: PropTypes.func.isRequired,
    isRater: PropTypes.bool.isRequired,
    subjectName: PropTypes.string.isRequired
};